import { ArrowBack, NavigateNext, TableView } from "@mui/icons-material";
import {
  Box,
  Breadcrumbs,
  CircularProgress,
  Grid,
  Pagination,
  PaginationItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { FilterConsAPagar } from "../../components/filter/FilterConsAPagar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import CustomDatagrid from "../../components/datagrid/CustomDatagrid";
import Colors from "../../components/constants/Colors";
import { doctosListMock, estabsListMock } from "./mock/ConsultaMock";
import axios from "axios";
import errorHandler from "../../components/core/store/errorHandler";
import { headers } from "../../components/core/store/localStorage";
import { usePaginationQuery } from "../../helpers/pagination";

const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

export const ContasAPagarConsulta = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setQueryParams } = usePaginationQuery();

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const page = Number(query.get("page") || 1);
  const filter = query.get("filtro");
  const isMobile = useMediaQuery("(max-width: 375px)");

  const [head, setHead] = useState([]);
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({});
  const [totalPages, setTotalPages] = useState(0);

  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [titleLoading, setTitleLoading] = useState("Carregando...");
  const [searchValue, setSearchValue] = useState("");
  const [showGrid, setShowGrid] = useState(false);
  const [isSearch, setIsSearch] = useState(true);

  const [fornecedor, setFornecedor] = useState("");
  const [fornecedorList, setFornecedorList] = useState([]);
  const [banco, setBanco] = useState("");
  const [bancoList, setBancoList] = useState([]);
  const [agencia, setAgencia] = useState("");
  const [agenciaList, setAgenciaList] = useState([]);
  const [contaCorrente, setContaCorrente] = useState("");
  const [contaCorrenteList, setContaCorrenteList] = useState([]);
  const [numDoc, setNumDoc] = useState("");
  const [centroCusto, setCentroCusto] = useState("");
  const [centroCustoList, setCentroCustoList] = useState([]);
  const [despesa, setDespesa] = useState("");
  const [despesaList, setDespesaList] = useState([]);
  const [contaContabil, setContaContabil] = useState("");
  const [situacaoAberto, setSituacaoAberto] = useState(false);
  const [situacaoPago, setSituacaoPago] = useState(false);
  const [todosDocto, setTodosDocto] = useState(false);
  const [doctosList, setDoctosList] = useState(doctosListMock);
  const [todosEstab, setTodosEstab] = useState(false);
  const [estabsList, setEstabsList] = useState([]);
  const [dataEmissaoIni, setDataEmissaoIni] = useState("");
  const [dataEmissaoFim, setDataEmissaoFim] = useState("");
  const [dataPrevisaoIni, setDataPrevisaoIni] = useState("");
  const [dataPrevisaoFim, setDataPrevisaoFim] = useState("");
  const [dataVencimentoIni, setDataVencimentoIni] = useState("");
  const [dataVencimentoFim, setDataVencimentoFim] = useState("");
  const [tipoDoc, setTipoDoc] = useState("");
  const [tipoDocList, setTipoDocList] = useState([]);
  const [estabelecimento, setEstabelecimento] = useState("");
  const [estabelecimentoList, setEstabelecimentoList] = useState([]);
  const [planoContas, setPlanoContas] = useState("");
  const [planoContasList, setPlanoContasList] = useState([]);
  const [dataLiquidadoIni, setDataLiquidadoIni] = useState("");
  const [dataLiquidadoFim, setDataLiquidadoFim] = useState("");

  const [hasSearched, setHasSearched] = useState(false);
  const [openPayloadModal, setOpenPayloadModal] = useState(false);
  const [payloadErrors, setPayloadErrors] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openBackModal, setOpenBackModal] = useState(false);

  useEffect(() => {
    if (API_URL === null) window.location.href = "/";
    getFornecedor();
    getTipoDoc();
    getEstabelecimento();
    // getAgenteCobrador();
    getCentroCusto();
    getDespesa();
    getPlanoContas();
    getContaCorrente();
    // getTipoPag();
  }, []);

  useEffect(() => {
    if (!hasSearched) return;
    fetchContasAPagar(page, filter);
  }, [page, filter, hasSearched]);

  const getFornecedor = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/fornecedor/combo`,
        headers(),
      );

      setFornecedorList(response.data.fornecedor || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const getTipoDoc = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/tipodocumento/combo`,
        headers(),
      );
      setDoctosList(response.data.tipodocumento || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const getEstabelecimento = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/estabelecimento/combo`,
        headers(),
      );
      setEstabsList(response.data.estabelecimento || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const getCentroCusto = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/centrocusto/combo`,
        headers(),
      );
      setCentroCustoList(response.data.centrocusto || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const getDespesa = async () => {
    try {
      const response = await axios.get(`${API_URL}/despesa/combo`, headers());
      setDespesaList(response.data.despesa || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const getPlanoContas = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/planocontas/combo`,
        headers(),
      );
      setPlanoContasList(response.data.planocontas || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const getContaCorrente = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/contacorrente/combo`,
        headers(),
      );

      setContaCorrenteList(response.data.contacorrente || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const searchContasAPagar = () => {
    setHasSearched(true);

    const qp = { page: 1 };

    if (fornecedor?.trim()) qp.fornecedorId = fornecedor.trim();
    if (banco?.trim()) qp.bancoId = banco.trim();
    if (agencia?.trim()) qp.agenciaId = agencia.trim();
    if (contaCorrente?.trim()) qp.contaId = contaCorrente.trim();
    if (contaContabil?.trim()) qp.contaContabilId = contaContabil.trim();
    if (numDoc?.trim()) qp.numDoc = numDoc.trim();
    if (centroCusto?.trim()) qp.centroCustoId = centroCusto.trim();
    if (despesa?.trim()) qp.despesaId = despesa.trim();
    const idsEstabs = (estabsList ?? [])
      .filter((e) => e.checked)
      .map((e) => e.id)
      .join(",");

    if (idsEstabs) qp.estabelecimentoId = idsEstabs;

    const idsDoctos = (doctosList ?? [])
      .filter((d) => d.checked)
      .map((d) => d.id)
      .join(",");

    if (idsDoctos) qp.tipoDocId = idsDoctos;
    if (planoContas?.trim()) qp.planoContasId = planoContas.trim();
    if (dataEmissaoIni?.trim()) qp.dataEmissaoIni = dataEmissaoIni.trim();
    if (dataEmissaoFim?.trim()) qp.dataEmissaoFim = dataEmissaoFim.trim();
    if (dataPrevisaoIni?.trim()) qp.dataPrevisaoIni = dataPrevisaoIni.trim();
    if (dataPrevisaoFim?.trim()) qp.dataPrevisaoFim = dataPrevisaoFim.trim();
    if (dataVencimentoIni?.trim()) qp.dataInicio = dataVencimentoIni.trim();
    if (dataVencimentoFim?.trim()) qp.dataFim = dataVencimentoFim.trim();
    if (dataLiquidadoIni?.trim()) qp.dataLiquidadoIni = dataLiquidadoIni.trim();
    if (dataLiquidadoFim?.trim()) qp.dataLiquidadoFim = dataLiquidadoFim.trim();
    if (situacaoAberto && !situacaoPago) {
      qp.situacao = "1";
    } else if (!situacaoAberto && situacaoPago) {
      qp.situacao = "2";
    }

    setQueryParams(qp, false);
    fetchContasAPagar(1, qp);
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 1;
    let totalPages = 1;
    setLoading(true);
    setShowGrid(false);

    try {
      do {
        const params = new URLSearchParams(location.search);
        params.set("page", String(currentPage));

        if (fornecedor?.trim()) params.set("fornecedorId", fornecedor.trim());
        if (banco?.trim()) params.set("bancoId", banco.trim());
        if (agencia?.trim()) params.set("agencia", agencia.trim());
        if (contaCorrente?.trim())
          params.set("contaCorrenteId", contaCorrente.trim());
        if (numDoc?.trim()) params.set("numDoc", numDoc.trim());
        if (contaContabil?.trim())
          params.set("contaContabilId", contaContabil.trim());
        if (centroCusto?.trim())
          params.set("centroCustoId", centroCusto.trim());
        if (despesa?.trim()) params.set("despesaId", despesa.trim());

        const idsEstabs = (estabsList ?? [])
          .filter((e) => e.checked)
          .map((e) => e.id)
          .join(",");
        if (idsEstabs) params.set("estabelecimentoId", idsEstabs);

        const idsDoctos = (doctosList ?? [])
          .filter((d) => d.checked)
          .map((d) => d.id)
          .join(",");
        if (idsDoctos) params.set("tipoDocId", idsDoctos);
        if (planoContas?.trim())
          params.set("planoContasId", planoContas.trim());
        if (dataEmissaoIni?.trim())
          params.set("dataEmissaoIni", dataEmissaoIni.trim());
        if (dataEmissaoFim?.trim())
          params.set("dataEmissaoFim", dataEmissaoFim.trim());
        if (dataPrevisaoIni?.trim())
          params.set("dataPrevisaoIni", dataPrevisaoIni.trim());
        if (dataPrevisaoFim?.trim())
          params.set("dataPrevisaoFim", dataPrevisaoFim.trim());
        if (dataVencimentoIni?.trim())
          params.set("dataInicio", dataVencimentoIni.trim());
        if (dataVencimentoFim?.trim())
          params.set("dataFim", dataVencimentoFim.trim());
        if (situacaoAberto && !situacaoPago) {
          params.set("situacao", "1");
        } else if (!situacaoAberto && situacaoPago) {
          params.set("situacao", "2");
        } else {
          params.delete("situacao");
        }
        if (dataLiquidadoIni?.trim())
          params.set("dataLiquidadoIni", dataLiquidadoIni.trim());
        if (dataLiquidadoFim?.trim())
          params.set("dataLiquidadoFim", dataLiquidadoFim.trim());

        const url = `${API_URL}/contasapagar?${params.toString()}`;
        const response = await axios.get(url, headers());
        const payload = response?.data || {};

        allData = allData.concat(payload.data || []);
        totalPages = Number(payload.totalPages || 1);
        currentPage++;
      } while (currentPage <= totalPages);

      return allData;
    } catch (error) {
      errorHandler(error);
      return null;
    } finally {
      setShowGrid(true);
      setLoading(false);
    }
  };

  const fetchContasAPagar = async (pageToFetch, qpOverride) => {
    setLoading(true);
    setIsSearch(false);
    setShowGrid(false);
    setNotFound(false);

    try {
      const params = new URLSearchParams(qpOverride ?? location.search);
      params.set("page", String(pageToFetch));
      if (fornecedor?.trim()) params.set("fornecedorId", fornecedor.trim());
      if (banco?.trim()) params.set("bancoId", banco.trim());
      if (agencia?.trim()) params.set("agenciaId", agencia.trim());
      if (contaCorrente?.trim()) params.set("contaId", contaCorrente.trim());
      if (numDoc?.trim()) params.set("numDoc", numDoc.trim());
      if (contaContabil?.trim())
        params.set("contaContabilId", contaContabil.trim());
      if (centroCusto?.trim()) params.set("centroCustoId", centroCusto.trim());
      if (despesa?.trim()) params.set("despesaId", despesa.trim());
      const idsEstabs = (estabsList ?? [])
        .filter((e) => e.checked)
        .map((e) => e.id)
        .join(",");

      if (idsEstabs) params.set("estabelecimentoId", idsEstabs);

      const idsDoctos = (doctosList ?? [])
        .filter((d) => d.checked)
        .map((d) => d.id)
        .join(",");

      if (idsDoctos) params.set("tipoDocId", idsDoctos);
      if (planoContas?.trim()) params.set("planoContasId", planoContas.trim());
      if (dataEmissaoIni?.trim())
        params.set("dataEmissaoIni", dataEmissaoIni.trim());
      if (dataEmissaoFim?.trim())
        params.set("dataEmissaoFim", dataEmissaoFim.trim());
      if (dataPrevisaoIni?.trim())
        params.set("dataPrevisaoIni", dataPrevisaoIni.trim());
      if (dataPrevisaoFim?.trim())
        params.set("dataPrevisaoFim", dataPrevisaoFim.trim());
      if (dataVencimentoIni?.trim())
        params.set("dataInicio", dataVencimentoIni.trim());
      if (dataVencimentoFim?.trim())
        params.set("dataFim", dataVencimentoFim.trim());

      if (situacaoAberto && !situacaoPago) {
        params.set("situacao", "1");
      } else if (!situacaoAberto && situacaoPago) {
        params.set("situacao", "2");
      }
      if (dataLiquidadoIni?.trim())
        params.set("dataLiquidadoIni", dataLiquidadoIni.trim());
      if (dataLiquidadoFim?.trim())
        params.set("dataLiquidadoFim", dataLiquidadoFim.trim());

      const url = `${API_URL}/contasapagar?${params.toString()}`;

      const response = await axios.get(url, headers());

      const payload = response?.data || {};

      const data = payload.data || [];
      const pages = Number(payload.totalPages || 1);

      setTotalPages(pages);

      if (pageToFetch > pages) {
        setQueryParams({ page: pages }, true);
        return;
      }

      if (data.length === 0) {
        setIsSearch(false);
        setNotFound(true);
        setShowGrid(false);
        if (pageToFetch > 1) setQueryParams({ page: 1 }, true);
        return;
      }

      setShowGrid(true);
      setIsSearch(false);
      setHead(payload.columns || []);
      setRows(data);
      setTotals(payload.totalizador || {});
      setNotFound(false);
    } catch (error) {
      setShowGrid(false);
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCentroCusto = async (e) => {
    const centroCustoId = e.target.value;
    setCentroCusto(centroCustoId);

    try {
      const response = await axios.get(
        `${API_URL}/despesa/combo?centroCustoId=${centroCustoId}`,
        headers(),
      );

      setDespesaList(response.data.despesa || []);
    } catch (error) {
      errorHandler(error);
      setDespesaList([]);
    }
  };

  const handleChangeDespesa = async (e) => {
    const despesaId = e.target.value;
    setDespesa(despesaId);

    try {
      const response = await axios.get(
        `${API_URL}/centrocusto/combo?despesaId=${despesaId}`,
        headers(),
      );

      setCentroCustoList(response.data.centrocusto || []);
    } catch (error) {
      errorHandler(error);
      setCentroCustoList([]);
    }
  };

  const handleToggleAllDoctos = (checked) => {
    setTodosDocto(checked);

    setDoctosList((prevList) =>
      prevList.map((item) => ({ ...item, checked: checked })),
    );
  };

  const handleToggleDocto = (id, checked) => {
    const novaLista = doctosList.map((item) =>
      item.id === id ? { ...item, checked } : item,
    );
    setDoctosList(novaLista);

    const todosEstaoMarcados = novaLista.every((item) => item.checked);
    setTodosDocto(todosEstaoMarcados);
  };

  const handleToggleAllEstabs = (checked) => {
    setTodosEstab(checked);

    setEstabsList((prevList) =>
      prevList.map((item) => ({ ...item, checked: checked })),
    );
  };

  const handleToggleEstab = (id, checked) => {
    const novaLista = estabsList.map((item) =>
      item.id === id ? { ...item, checked } : item,
    );
    setEstabsList(novaLista);

    const todosEstaoMarcados = novaLista.every((item) => item.checked);
    setTodosEstab(todosEstaoMarcados);
  };

  const handleBack = () => {
    setIsSearch(true);
    setShowGrid(false);
    setLoading(false);
    setNotFound(false);

    // setDoctosList((prev) => prev.map((i) => ({ ...i, checked: todosDocto })));
    // setEstabsList((prev) => prev.map((i) => ({ ...i, checked: todosEstab })));
  };

  const exportCsv = async () => {
    const completeData = await fetchAllDataForExport();

    if (!completeData || completeData.length === 0) {
      alert("Não há dados para exportar.");
      return;
    }

    const headers = [
      "Número",
      "Parcela",
      "Fornecedor",
      "Data Vencto.",
      "Situação",
      "Valor Título",
    ];

    const csvRows = completeData.map((item) => [
      item.numTitulo || "",
      item.parcela || "",
      item.name || "",
      item.dataVencto || "",
      item.statusLiquidado || "",
      String(item.valorCorrigido || "")
        .replace("R$", "")
        .trim(),
    ]);

    if (totals && totals.name) {
      csvRows.push([
        "",
        "",
        totals.name,
        "",
        "",
        String(totals.valorCorrigido || "").trim(),
      ]);
    }

    const csvContent = [
      headers.join(";"),
      ...csvRows.map((row) => row.join(";")),
    ].join("\n");

    const blob = new Blob(["\ufeff" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `relatorio_completo_${new Date().getTime()}.csv`,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid wrap="wrap">
          <Grid
            size={{ xs: 6, sm: 7, md: 8, xl: 10 }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Breadcrumbs
              separator={<NavigateNext fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Typography
                className={css(styles.pageTitle)}
                sx={{ fontWeight: 400, color: "#828282" }}
              >
                Contas a Pagar
              </Typography>
              <Typography className={css(styles.pageTitle)}>
                Consulta
              </Typography>
            </Breadcrumbs>
            <div style={{ display: "flex", gap: "5px" }}>
              {!isSearch && (
                <Box sx={{ display: "flex", gap: "5px" }}>
                  <button
                    onClick={handleBack}
                    className={css(styles.topBtn)}
                    title="Voltar"
                  >
                    <ArrowBack style={{ fontSize: "1.4rem" }} />
                  </button>

                  <button
                    onClick={exportCsv}
                    className={css(styles.topBtn)}
                    title="Exportar para Excel"
                  >
                    <TableView style={{ fontSize: "1.4rem" }} />
                  </button>
                </Box>
              )}
            </div>
          </Grid>
        </Grid>
        <hr
          style={{
            color: "#eee",
            marginBottom: "1rem",
          }}
        />

        <Box sx={{ maxWidth: 1200, mx: "auto" }}>
          {isSearch ? (
            <>
              <FilterConsAPagar
                dataLiquidadoIni={dataLiquidadoIni}
                setDataLiquidadoIni={setDataLiquidadoIni}
                dataLiquidadoFim={dataLiquidadoFim}
                setDataLiquidadoFim={setDataLiquidadoFim}
                handleChangeCentroCusto={handleChangeCentroCusto}
                handleChangeDespesa={handleChangeDespesa}
                fornecedor={fornecedor}
                fornecedorList={fornecedorList}
                setFornecedor={setFornecedor}
                banco={banco}
                bancosList={contaCorrenteList}
                agenciasList={contaCorrenteList}
                contaCorrenteList={contaCorrenteList}
                setBanco={setBanco}
                agencia={agencia}
                setAgencia={setAgencia}
                contaCorrente={contaCorrente}
                setContaCorrente={setContaCorrente}
                numDoc={numDoc}
                setNumDoc={setNumDoc}
                centroCusto={centroCusto}
                centroCustoList={centroCustoList}
                setCentroCusto={setCentroCusto}
                despesa={despesa}
                despesaList={despesaList}
                setDespesa={setDespesa}
                situacaoAberto={situacaoAberto}
                setSituacaoAberto={setSituacaoAberto}
                planoContas={planoContas}
                planoContasList={planoContasList}
                setPlanoContas={setPlanoContas}
                situacaoPago={situacaoPago}
                setSituacaoPago={setSituacaoPago}
                todosDocto={todosDocto}
                setTodosDocto={handleToggleAllDoctos}
                onToggleDocto={handleToggleDocto}
                doctosList={doctosList}
                setDoctosList={setDoctosList}
                todosEstab={todosEstab}
                setTodosEstab={handleToggleAllEstabs}
                onToggleEstab={handleToggleEstab}
                estabsList={estabsList}
                setEstabsList={setEstabsList}
                dataEmissaoIni={dataEmissaoIni}
                setDataEmissaoIni={setDataEmissaoIni}
                dataEmissaoFim={dataEmissaoFim}
                setDataEmissaoFim={setDataEmissaoFim}
                dataPrevisaoIni={dataPrevisaoIni}
                setDataPrevisaoIni={setDataPrevisaoIni}
                dataPrevisaoFim={dataPrevisaoFim}
                setDataPrevisaoFim={setDataPrevisaoFim}
                dataVencimentoIni={dataVencimentoIni}
                setDataVencimentoIni={setDataVencimentoIni}
                dataVencimentoFim={dataVencimentoFim}
                setDataVencimentoFim={setDataVencimentoFim}
                consultar={searchContasAPagar}
              />
            </>
          ) : null}

          {showGrid ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "grid",
                }}
              >
                <CustomDatagrid
                  head={head}
                  row={rows}
                  totals={totals}
                  loading={loading}
                  // onEyeClick={(row) => console.log("ver", row)}
                  // onEditClick={(row) => handleEdit(row)}
                  // columnOverrides={{
                  //   id: { minWidth: 150, maxWidth: 250 },
                  //   name: { minWidth: 200 },
                  // }}
                  // hasTotal={true}
                />
                {totalPages > 1 && (
                  <Pagination
                    page={page}
                    count={totalPages}
                    showFirstButton
                    showLastButton
                    sx={{
                      mt: 1,
                      "& .MuiPaginationItem-root.Mui-selected": {
                        background: Colors.mainLayoutAtiveBackground,
                        color: "black",
                      },
                    }}
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        component={Link}
                        to={`/contas-a-pagar/consulta${
                          item.page
                            ? `?page=${item.page}${filter ? `&filtro=${filter}` : ""}`
                            : ""
                        }`}
                      />
                    )}
                  />
                )}
              </Box>
            </>
          ) : null}
          {loading ? (
            <Box
              width={"100%"}
              height={"45vh"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid
                item
                xs={12}
                md={12}
                textAlign={"center"}
                justifyContent={"center"}
                alignItems={"center"}
                bgcolor={"#cadccaff"}
                borderRadius={5}
                padding={5}
                color={Colors.noResultFont}
              >
                <div display={"flex"} style={{ marginTop: "-0.5rem" }}>
                  <CircularProgress color="success" />
                </div>
                <div display={"flex"}>
                  <p
                    style={{
                      color: "#4b4b4b",
                      fontSize: 14,
                      marginBottom: "-1rem",
                    }}
                  >
                    {titleLoading}
                  </p>
                </div>
              </Grid>
            </Box>
          ) : null}
          {notFound ? (
            <Box
              width={"100%"}
              height={"45vh"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid
                size={{ xs: 12, md: 12 }}
                height={{ md: "20%", xs: "50%" }}
                display={"inline-flex"}
                textAlign={"center"}
                justifyContent={"center"}
                alignItems={"center"}
                bgcolor={"lightyellow"}
                borderRadius={5}
                padding={5}
                color={Colors.noResultFont}
              >
                <p
                  style={{
                    color: "#4b4b4b",
                    fontSize: 14,
                  }}
                >
                  Sua pesquisa não retornou nenhum resultado.
                </p>
              </Grid>
            </Box>
          ) : null}
        </Box>
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
    fontSize: 14,
    margin: 0,
  },
  head: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 1.5,
  },

  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
    textDecoration: "none",
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 4,
    marginTop: "-0.5rem",
    cursor: "pointer",

    padding: "5px 8px 3px 8px",
    transitionDuration: "0.2s",

    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  topBtn: {
    backgroundColor: "#669966",
    cursor: "pointer",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: "4px 8px",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
    "@media (max-width: 375px)": {
      fontSize: 10,
      padding: "0.3rem 0.5rem",
    },
  },
});
